import 'whatwg-fetch'; 
import config from '../config';
const getAuthToken = () => localStorage.getItem('authToken');

const request = method => async (resource, options = {}) => {
    const { apiRoot } = config;
  
    if (!resource || !apiRoot) return null;
    return await fetch(`${apiRoot}/${resource}`, {
        method,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        ...options
    })
    .then((result) => {
        if (result.ok) {
            return result.json();
        } else {
            return result.text().then(bodyText => {
                if (bodyText === '' && result.statusText !== '') {
                    return '{"status":"NOK","result":{"error":"' + result.statusText + '"}}';
                }

                if (bodyText === 'Expired Token') {
                    // Clear localStorage
                    localStorage.clear();
                    // Add an explicit throw to halt the promise chain.
                    throw new Error("Expired Token");
                } else if (bodyText === 'EXDT') {
                    // Clear localStorage
                    localStorage.clear();
                    // Add an explicit throw to halt the promise chain.
                    throw new Error("EXDT");
                } else {
                    return '{"status":"NOK","result":{"error":"' + bodyText + '"}}';
                }
            });
        }
    })
    .catch((error) => {
        if (error.message === 'Expired Token') {
            // Redirect the user to the home screen via logout
            window.location.replace('/logout');
            // Throw an uncaught exception here to prevent any further activity.
            throw new Error("Expired Token");
        } else if (error.message === 'EXDT') {
            // Redirect the user to the home screen via logout
            window.location.replace('/logout');
            // Throw an uncaught exception here to prevent any further activity.
            throw new Error("EXDT");
        } else {
            return '{"status":"NOK","result":{"error":"Unknown Error"}}';
        }
    });
};

export default {
    get: request('GET'),
    post: request('POST'),
    patch: request('PATCH'),
    put: request('PUT'),
    delete: request('DELETE'),
    getAuthToken: getAuthToken
};
